import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router'
import moment from 'moment-timezone'

import './ModifyRecurrence.scss'
import ProfileMobileNavBar from 'components/ProfileMobileNavBar'
import AliadaProfileCard from 'components/AliadaProfileCard'
import ModifyServiceMenuItem from 'components/ModifyServiceMenuItem'
import { buildAddressString } from 'utils/addresses'
import { formatDate, pluralizedWeekday } from 'utils/dates'
import { TIMEZONE } from '@src/globals'
import * as paths from 'utils/paths'

class ModifyRecurrence extends Component {
  componentDidMount () {
    const {
      fetchRecurrence,
      params: {
        recurrenceId
      }
    } = this.props

    fetchRecurrence(recurrenceId)
  }

  humanizeRecurrencePeriodicity (moment, periodicity) {
    const recurrenceDayOfWeek = pluralizedWeekday(moment)

    switch (periodicity) {
      default:
      case 7:
        return `Todos los ${recurrenceDayOfWeek}`
      case 14:
        return `Los ${recurrenceDayOfWeek} cada dos semanas`
    }
  }

  isLoading () {
    const { recurrence, aliada } = this.props
    return !recurrence || !aliada
  }

  render () {
    if (this.isLoading()) {
      const Loader = () => <div />
      return <Loader />
    }

    const {
      recurrence,
      aliada,
      params: { userId }
    } = this.props

    const {
      services,
      estimatedHours,
      weekday,
      hour,
      periodicity
    } = recurrence

    const recurrenceMoment = moment.tz(Date.now(0), TIMEZONE).day(weekday).hour(hour).minute(0)
    const recurrenceTime = formatDate('h:mm A', recurrenceMoment)

    return (
      <div className='ModifyRecurrence navbar-screen'>
        <ProfileMobileNavBar back>
          Modificar Recurrencia
        </ProfileMobileNavBar>

        <div className='ModifyRecurrence-content navbar-screen-content'>
          <div className='ModifyRecurrence-contentCard'>
            <div className='ModifyRecurrence-cardTitle'>
              Modificar recurrencia
            </div>

            <div className='ModifyRecurrence-cardBody'>
              <AliadaProfileCard
                aliada={aliada}
                estimatedServiceHours={estimatedHours}
              />

              <div className='ModifyRecurrence-recurrenceInfo'>
                <div className='ModifyRecurrence-infoField ModifyRecurrence-column100'>
                  <div className='ModifyRecurrence-infoFieldLabel'>Día de los servicios</div>
                  <div className='ModifyRecurrence-infoFieldData'>{this.humanizeRecurrencePeriodicity(recurrenceMoment, periodicity)}</div>
                </div>

                <div className='ModifyRecurrence-infoField ModifyRecurrence-column50'>
                  <div className='ModifyRecurrence-infoFieldLabel'>Hora</div>
                  <div className='ModifyRecurrence-infoFieldData'>{recurrenceTime}</div>
                </div>

                <div className='ModifyRecurrence-infoField ModifyRecurrence-column50'>
                  <div className='ModifyRecurrence-infoFieldLabel'>Duración</div>
                  <div className='ModifyRecurrence-infoFieldData'>{Number.parseInt(estimatedHours)} horas</div>
                </div>

                <div className='ModifyRecurrence-infoAddress ModifyRecurrence-column100'>
                  {buildAddressString(services[0].address)}
                </div>
              </div>

              <div className='ModifyRecurrence-menu'>
                <ModifyServiceMenuItem
                  icon='calendar'
                  to={paths.rescheduleRecurrence(userId, recurrence.id)}
                  label='Modificar fecha y hora'
                  />

                <ModifyServiceMenuItem
                  icon='user'
                  to={paths.recurrenceChangeAliadaSearch(userId, recurrence.id)}
                  label='Cambiar de Aliada'
                  />
              </div>

              <div className='ModifyRecurrence-buttons'>
                <Link
                  className='ModifyRecurrence-cancelButton btn btn-default btn-lg btn-block'
                  to={paths.userCancelRecurrence(userId, recurrence.id)}
                  >
                  Cancelar recurrencia
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ModifyRecurrence.displayName = 'ModifyRecurrence'
ModifyRecurrence.propTypes = {
  recurrence: PropTypes.object
}
ModifyRecurrence.defaultProps = {}

export default ModifyRecurrence



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/ModifyRecurrence/ModifyRecurrence.js